<template>
  <svg
    class="custom-icon"
    width="38"
    height="33"
    viewBox="0 0 38 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.34969 33C1.49829 33 0 31.4699 0 29.5817V11.3838C0 9.49462 1.49939 7.96524 3.35646 7.96524H12.8525C13.8441 7.96524 14.972 8.58122 15.5233 9.42302L16.5133 10.9349C16.651 11.1451 17.0787 11.3789 17.3256 11.3789H27.9398C29.7917 11.3789 31.2943 12.9037 31.2943 14.7874V29.5915C31.2943 31.4738 29.7937 32.9997 27.9446 32.9997L3.34969 33ZM6.70591 6.25866V3.41511C6.70591 1.52915 8.20669 0 10.0583 0H19.5584C20.55 0 21.678 0.615984 22.229 1.45755L23.219 2.96966C23.3566 3.17983 23.7846 3.4137 24.0313 3.4137H34.6438C36.4966 3.4137 38 4.93825 38 6.82191V21.6266C38 23.5096 36.4974 25.0348 34.6456 25.0348H32.9705V14.7877C32.9705 11.9609 30.7171 9.67236 27.9397 9.67236H17.7016L16.9185 8.47628C16.0564 7.16005 14.4053 6.25861 12.8528 6.25861L6.70591 6.25866Z"
    />
  </svg>
</template>
